import { PaddingState } from '../../common/types/padding/PaddingState';

export type SpacerState = PaddingState & {
  height: number;
};
